"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_PLATFORM_TYPE_DEUS_TITLE_KR = exports.EN_PLATFORM_TYPE_DEUS = exports.EN_PLATFORM_TYPE_FROM_CLIENT = exports.EN_PLATFORM_TYPE_IN_HEADER = exports.EN_DEVICE_TYPE_BY_ACCESS_TOKEN = exports.EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE = exports.EN_DEVICE_SHORTCUT_UPPERCASE = exports.EN_DEVICE_SHORTCUT = exports.EN_DEVICE_TYPE_FOR_MEMBER_API = exports.EN_DEVICE_TYPE = exports.EN_DEVICE_CODE = void 0;
/** internal api 에 정의된 디바이스 유형 */
var EN_DEVICE_CODE;
(function (EN_DEVICE_CODE) {
    /** 안드로이드 */
    EN_DEVICE_CODE[EN_DEVICE_CODE["ANDROID"] = 1] = "ANDROID";
    /** iOS */
    EN_DEVICE_CODE[EN_DEVICE_CODE["IOS"] = 2] = "IOS";
    /** PC 웹 */
    EN_DEVICE_CODE[EN_DEVICE_CODE["PC_WEB"] = 3] = "PC_WEB";
    /** 모바일 웹 */
    EN_DEVICE_CODE[EN_DEVICE_CODE["MOBILE_WEB"] = 4] = "MOBILE_WEB";
    /** 알수 없음 */
    EN_DEVICE_CODE[EN_DEVICE_CODE["UNKNOWN"] = 99] = "UNKNOWN";
})(EN_DEVICE_CODE = exports.EN_DEVICE_CODE || (exports.EN_DEVICE_CODE = {}));
/** 디바이스 유형 toString */
var EN_DEVICE_TYPE;
(function (EN_DEVICE_TYPE) {
    /** 안드로이드 (device 1) */
    EN_DEVICE_TYPE["ANDROID"] = "ANDROID";
    /** iOS (device 2) */
    EN_DEVICE_TYPE["IOS"] = "IOS";
    /** PC 웹 (device 3) */
    EN_DEVICE_TYPE["PC_WEB"] = "PC_WEB";
    /** 모바일 웹 (device 4) */
    EN_DEVICE_TYPE["MOBILE_WEB"] = "MOBILE_WEB";
})(EN_DEVICE_TYPE = exports.EN_DEVICE_TYPE || (exports.EN_DEVICE_TYPE = {}));
/**
 * Member API 에서 사용하는 디바이스 유형 string value (...)
 * @see https://confluence.yanolja.in/display/platformdiv/APIs+SPEC#expand-
 */
var EN_DEVICE_TYPE_FOR_MEMBER_API;
(function (EN_DEVICE_TYPE_FOR_MEMBER_API) {
    /** 안드로이드 (device 1) */
    EN_DEVICE_TYPE_FOR_MEMBER_API["ANDROID"] = "ANDROID";
    /** iOS (device 2) */
    EN_DEVICE_TYPE_FOR_MEMBER_API["IOS"] = "IOS";
    /** PC 웹 (device 3) */
    EN_DEVICE_TYPE_FOR_MEMBER_API["PC_WEB"] = "PC";
    /** 모바일 웹 (device 4) */
    EN_DEVICE_TYPE_FOR_MEMBER_API["MOBILE_WEB"] = "MWEB";
})(EN_DEVICE_TYPE_FOR_MEMBER_API = exports.EN_DEVICE_TYPE_FOR_MEMBER_API || (exports.EN_DEVICE_TYPE_FOR_MEMBER_API = {}));
/** 디바이스 유형 shortcut string (소문자) */
var EN_DEVICE_SHORTCUT;
(function (EN_DEVICE_SHORTCUT) {
    /** 안드로이드 (device 1) */
    EN_DEVICE_SHORTCUT["ANDROID"] = "and";
    /** iOS (device 2) */
    EN_DEVICE_SHORTCUT["IOS"] = "ios";
    /** PC 웹 (device 3) */
    EN_DEVICE_SHORTCUT["PC_WEB"] = "pw";
    /** 모바일 웹 (device 4) */
    EN_DEVICE_SHORTCUT["MOBILE_WEB"] = "mw";
})(EN_DEVICE_SHORTCUT = exports.EN_DEVICE_SHORTCUT || (exports.EN_DEVICE_SHORTCUT = {}));
/** 디바이스 유형 shortcut string (대문자) */
var EN_DEVICE_SHORTCUT_UPPERCASE;
(function (EN_DEVICE_SHORTCUT_UPPERCASE) {
    /** 안드로이드 (device 1) */
    EN_DEVICE_SHORTCUT_UPPERCASE["ANDROID"] = "AND";
    /** iOS (device 2) */
    EN_DEVICE_SHORTCUT_UPPERCASE["IOS"] = "IOS";
    /** PC 웹 (device 3) */
    EN_DEVICE_SHORTCUT_UPPERCASE["PC_WEB"] = "PW";
    /** 모바일 웹 (device 4) */
    EN_DEVICE_SHORTCUT_UPPERCASE["MOBILE_WEB"] = "MW";
})(EN_DEVICE_SHORTCUT_UPPERCASE = exports.EN_DEVICE_SHORTCUT_UPPERCASE || (exports.EN_DEVICE_SHORTCUT_UPPERCASE = {}));
var EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE;
(function (EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE) {
    EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE["AND"] = "ANDROID";
    EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE["IOS"] = "IOS";
    EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE["PW"] = "PC_WEB";
    EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE["MW"] = "MOBILE_WEB";
})(EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE = exports.EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE || (exports.EN_DEVICE_SHORTCUT_UPPERCASE_REVERSE = {}));
/** TApplicationDeviceOSs 와 매핑된 deviceType 값 */
var EN_DEVICE_TYPE_BY_ACCESS_TOKEN;
(function (EN_DEVICE_TYPE_BY_ACCESS_TOKEN) {
    EN_DEVICE_TYPE_BY_ACCESS_TOKEN["android"] = "ANDROID";
    EN_DEVICE_TYPE_BY_ACCESS_TOKEN["ios"] = "IOS";
    EN_DEVICE_TYPE_BY_ACCESS_TOKEN["sunny-web"] = "MOBILE_WEB";
})(EN_DEVICE_TYPE_BY_ACCESS_TOKEN = exports.EN_DEVICE_TYPE_BY_ACCESS_TOKEN || (exports.EN_DEVICE_TYPE_BY_ACCESS_TOKEN = {}));
/**
 * 클라이언트 측에서 요청 헤더에 기본적으로 포함시키는 platform 값
 * @deprecated EN_PLATFORM_TYPE_XXX 로 통일하는게 나을것 같아서 EN_PLATFORM_TYPE_FROM_CLIENT 사용 바랍니다
 */
var EN_PLATFORM_TYPE_IN_HEADER;
(function (EN_PLATFORM_TYPE_IN_HEADER) {
    EN_PLATFORM_TYPE_IN_HEADER["ANDROID"] = "Android";
    EN_PLATFORM_TYPE_IN_HEADER["IOS"] = "iOS";
    EN_PLATFORM_TYPE_IN_HEADER["PC_WEB"] = "Web";
    EN_PLATFORM_TYPE_IN_HEADER["MOBILE_WEB"] = "MWeb";
})(EN_PLATFORM_TYPE_IN_HEADER = exports.EN_PLATFORM_TYPE_IN_HEADER || (exports.EN_PLATFORM_TYPE_IN_HEADER = {}));
/** 클라이언트 측에서 요청 헤더에 기본적으로 포함시키는 platform 값 */
var EN_PLATFORM_TYPE_FROM_CLIENT;
(function (EN_PLATFORM_TYPE_FROM_CLIENT) {
    EN_PLATFORM_TYPE_FROM_CLIENT["ANDROID"] = "Android";
    EN_PLATFORM_TYPE_FROM_CLIENT["IOS"] = "iOS";
    EN_PLATFORM_TYPE_FROM_CLIENT["PW"] = "Web";
    EN_PLATFORM_TYPE_FROM_CLIENT["MW"] = "MWeb";
})(EN_PLATFORM_TYPE_FROM_CLIENT = exports.EN_PLATFORM_TYPE_FROM_CLIENT || (exports.EN_PLATFORM_TYPE_FROM_CLIENT = {}));
/** deus-api에서 사용되는 platform 유형 */
var EN_PLATFORM_TYPE_DEUS;
(function (EN_PLATFORM_TYPE_DEUS) {
    EN_PLATFORM_TYPE_DEUS["ANDROID"] = "android";
    EN_PLATFORM_TYPE_DEUS["IOS"] = "ios";
    EN_PLATFORM_TYPE_DEUS["PW"] = "pw";
    EN_PLATFORM_TYPE_DEUS["MW"] = "mw";
})(EN_PLATFORM_TYPE_DEUS = exports.EN_PLATFORM_TYPE_DEUS || (exports.EN_PLATFORM_TYPE_DEUS = {}));
/** EN_DEUS_PLATFORM_TYPE 을 한글로 표현해서 보여주기 위한 용도 */
var EN_PLATFORM_TYPE_DEUS_TITLE_KR;
(function (EN_PLATFORM_TYPE_DEUS_TITLE_KR) {
    EN_PLATFORM_TYPE_DEUS_TITLE_KR["ANDROID"] = "\uC571(Android App)";
    EN_PLATFORM_TYPE_DEUS_TITLE_KR["IOS"] = "\uC571(iOS App)";
    EN_PLATFORM_TYPE_DEUS_TITLE_KR["PW"] = "\uC6F9(PC Web)";
    EN_PLATFORM_TYPE_DEUS_TITLE_KR["MW"] = "\uC6F9(Mobible Web)";
})(EN_PLATFORM_TYPE_DEUS_TITLE_KR = exports.EN_PLATFORM_TYPE_DEUS_TITLE_KR || (exports.EN_PLATFORM_TYPE_DEUS_TITLE_KR = {}));
//# sourceMappingURL=data:application/json;base64,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